module.exports = __webpack_public_path__ + "img/s2.5f24a17b.png";